import { render, staticRenderFns } from "./basicPlan.vue?vue&type=template&id=24c24c52&scoped=true&"
import script from "./basicPlan.vue?vue&type=script&lang=js&"
export * from "./basicPlan.vue?vue&type=script&lang=js&"
import style0 from "./basicPlan.vue?vue&type=style&index=0&id=24c24c52&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c24c52",
  null
  
)

export default component.exports